;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .factory('TraceService', TraceService)

  function TraceService($q, logger, traceApiConfig, ErrorService) {
    'ngInject'

    var service = {
      sendToBugtracker: sendToBugtracker
    }

    return service

    function sendToBugtracker(appId, bugtrackerId, data) {
      return traceApiConfig
        .sendToBugtracker(appId, bugtrackerId, data)
        .then(function (response) {
          var data = response.data
          if (data.success_msg) {
            logger.logSuccess(data.success_msg)
          }
          if (data.bugtracker_attachment_errors) {
            _.each(data.bugtracker_attachment_errors, function (error) {
              logger.logError(error)
            })
          }
          return response
        })
        .catch(function (response) {
          var data = response.data
          var returnVal = {
            errorCode: data.error_code,
            errorMsgs: []
          }
          if (data.bugtracker_errors) {
            _.each(data.bugtracker_errors, function (error) {
              returnVal.errorMsgs.push(error)
            })
          }
          if (data.fail_msg) {
            logger.logError(data.fail_msg)
            // This is intentional
            if (data.success_msg) {
              logger.logSuccess(data.success_msg)
            }
          } else {
            ErrorService.processError(response)
          }
          return $q.reject(returnVal)
        })
    }
  }
})()
